import bootbox from "./bootbox.min";

$(document).on('turbolinks:load', function () {
    var purchaseTermsConfirmCheckbox = document.getElementById('purchase_terms_confirm');
    var orderCreateBtn = document.querySelector('.ffh-order-create-btn');
    var orderNewFormEl = document.getElementById('new_order');
    var cancelMyOrderBtn = document.getElementById('cancel_my_order');
    var realCancelMyOrderBtn = document.getElementById('real_cancel_my_order');

    if (purchaseTermsConfirmCheckbox && orderCreateBtn) {
        purchaseTermsConfirmCheckbox.onclick = function () {
            orderCreateBtn.disabled = !purchaseTermsConfirmCheckbox.checked;
        }
    }

    if (orderCreateBtn && orderNewFormEl) {
        orderCreateBtn.addEventListener('click', function (e) {
            e.preventDefault();
            bootbox.confirm({
                title: 'Härmed bekräftar jag min order',
                message: 'Vid nästa steg så har du möjligheten att betala din order.',
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i> Avbryt'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i> Gå vidare'
                    }
                },
                callback: function (result) {
                    if (result === true) {
                        orderNewFormEl.submit();
                    }
                }
            })
        })
    }

    if (cancelMyOrderBtn) {
        cancelMyOrderBtn.addEventListener('click', function (e) {
            e.preventDefault();

            bootbox.confirm({
                title: 'Härmed bekräftar jag att avbryta min order',
                message: 'Detta går inte att ångra efter att du klickat på Gå vidare.',
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i> Avbryt'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i> Gå vidare'
                    }
                },
                callback: function (result) {
                    if (result === true) {
                        realCancelMyOrderBtn.click();
                    }
                }
            })
        })
    }

    // Kontaktkopior kräver en bekräftelse innan bilden läggs i kundvagnen. Varje
    // produkt på bildsidan har en knapp och en dold länk som hör ihop via
    // produktens slug, så det fungerar oavsett vilka produkter som finns.
    var bootBoxContactPrintMessage = '<b>Observera:</b> <p class="mb-0"> Bilden är en kontaktkopia från ett förkommet negativ. <br/> Förstoringar kommer inte kunna levereras med samma detaljrikedom och skärpa som hade vi haft tillgång till originalnegativet. </p> <p class="mb-0 mt-4 mr-5"><span style="float:right">Jag beställer ändå:</span></p>';

    document.querySelectorAll('[data-contact-print-btn]').forEach(function (btnEl) {
        var slug = btnEl.getAttribute('data-contact-print-btn');
        var realLinkEl = document.querySelector('[data-contact-print-link="' + slug + '"]');

        if (!realLinkEl) {
            return;
        }

        btnEl.addEventListener('click', function () {
            bootbox.confirm({
                title: 'Observera',
                message: bootBoxContactPrintMessage,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i> Avbryt'
                    },
                    confirm: {
                        label: '<i class="fas fa-shopping-cart"></i> Lägg till i kundvagnen'
                    }
                },
                callback: function (result) {
                    if (result === true) {
                        realLinkEl.click();
                    }
                }
            })
        })
    });
});
